/**
 * Who sees the Developer Portal row in the left nav (above the profile menu).
 * One rule, pure: MFour staff with the `dev-portal` flag on. `isInternal` is
 * the nav's View-as-aware value (`useAccessContext`), so staff Viewing as a
 * client see what that client sees, which is no row.
 *
 * The page itself sits under /tools, which the (internal) layout already
 * keeps to staff. When the portal opens to outside developers this rule and
 * the route change together.
 */
import { Routes } from '@/app/routes';

export const DEV_PORTAL_FLAG = 'dev-portal';

export const DEV_PORTAL_NAV = {
    label: 'Developer Portal',
    railLabel: 'API',
    icon: 'code-xml',
    href: Routes.DEV_PORTAL,
} as const;

export function showsDevPortalInNav(viewer: {
    isInternal: boolean;
    hasFlag: (key: string) => boolean;
}): boolean {
    return viewer.isInternal && viewer.hasFlag(DEV_PORTAL_FLAG);
}
